var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"shop_area shop_fullwidth shop_reverse pt-27"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('product-list',{attrs:{"page_size":40}})],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }